import axios from 'services/api/axios';

export default {
  getList: async (queryString: string): Promise<Record<string, string>> => {
    const response = await axios.get(`/categories?${queryString}`);

    return response.data;
  },
};
